// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sU wu","ribbon":"sV wD","title":"sW ww","year":"sX wx","genres":"sY wC","duration":"sZ","buttonWrapper":"s0 wy","button":"s1 wz","price":"s2","upperParts":"s3"};